import request from 'utils/request'
import { MCAXS601InitRequest } from 'types/MCAXS601/MCAXS601InitRequest'

export const getMCAXS601InitRequest = (data: MCAXS601InitRequest) =>
  request({
    url: '/MCAXS601/init',
    method: 'post',
    data: data,
  })
